export const INVITATION_SUCCESS_MESSAGE = 'The invitation has been sent';
